import * as React from 'react';

type LegendProps = {
  children: React.ReactNode;
  isNested?: boolean;
};

function Legend({ children, isNested }: LegendProps): React.ReactElement {
  return (
    <div>
      <legend className="font-semibold ">{children}</legend>
    </div>
  );
}

export { Legend };
